import { createContext } from 'react';

export type SubAccountCreationCtx = {
  showSubAccountCreationErrorAlert: boolean;
  showSubAccountCreationSuccessAlert: boolean;
  subAccountCreationError: string;
};

const SubAccountCreationDialogueContext = createContext<SubAccountCreationCtx>({
  showSubAccountCreationErrorAlert: false,
  showSubAccountCreationSuccessAlert: false,
  subAccountCreationError: '',
});

export default SubAccountCreationDialogueContext;